export default __webpack_public_path__ + "static/media/Cotizacion-orange.a08b0c0b.svg";